import { Form as AntForm } from "antd"

const useForm = (customForm) => {
  const [ form ] = AntForm.useForm(customForm)
  return form
}

export default useForm
